<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true" id="pickup-modal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">ピックアップ追加</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <ul class="nav nav-tabs mb-3" v-if="this.books && this.books.writing">
                        <li class="nav-item">
                            <a href="#" class="nav-link" @click.prevent="status = 'writing'" :class="{active: status == 'writing'}">
                                執筆中
                                <span class="badge badge-primary">{{this.books.writing.length}}</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a href="#" class="nav-link" @click.prevent="status = 'finished'" :class="{active: status == 'finished'}">
                                完結
                                <span class="badge badge-primary">{{this.books.finished.length}}</span>
                            </a>
                        </li>
                        <li class="nav-item">
                            <a href="#" class="nav-link" @click.prevent="status = 'pending'" :class="{active: status == 'pending'}">
                                保留
                                <span class="badge badge-primary">{{this.books.pending.length}}</span>
                            </a>
                        </li>
                    </ul>
                    <pickup-book v-for="b in selectedBooks" :book="b" :key="b.id" @addPickup="addPickup"></pickup-book>
                    <div v-if="selectedBooks.length == 0">
                        小説はありません。
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">閉じる</button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.card {
    &:hover {
        background-color: #def;;
    }
}
</style>

<script>
import pickupBook from "./pickupBook";
export default {
    components: {
        pickupBook
    },
    props: {
        books: {
            default: null
        }
    },
    data() {
        return {
            status: "writing"
        }
    },
    methods: {
        addPickup(b) {
            if (b.pickup_number) return;
            axios.post("/mypage/books/pickup/add", {id: b.id}).then(res => {
                this.$emit("saved");
                $("#pickup-modal").modal("hide");
            });
        },
    },
    computed: {
        selectedBooks() {
            if (!this.books || !this.books[this.status]) return [];
            const selected = this.books[this.status] || [];
            return selected;
        }
    },
}
</script>